import { Control, Controller } from "react-hook-form";
import { Select } from "@thetreep/ui";
import { SearchRequest } from "@services/travel";

export interface TimeSelectProps {
  name: "outwardDate" | "inwardDate";
  control: Control<SearchRequest>;
  disabled?: boolean;
}

export function TimeSelect({ name, control, disabled }: TimeSelectProps) {
  function generateTimeOptions() {
    const options = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        const time = timeToString({ hours: hour, minutes: minute });
        options.push({ id: time, label: time });
      }
    }
    return options;
  }

  function dateToString(time: Date | undefined): string {
    if (!time) {
      return "05:00";
    }
    return `${String(time.getHours()).padStart(2, "0")}:${String(
      time.getMinutes(),
    ).padStart(2, "0")}`;
  }

  function timeToString(time: { hours: number; minutes: number }): string {
    return `${String(time.hours).padStart(2, "0")}:${String(
      time.minutes,
    ).padStart(2, "0")}`;
  }

  function stringToTime(time: string): { hours: number; minutes: number } {
    return {
      hours: parseInt(time.split(":")[0]),
      minutes: parseInt(time.split(":")[1]),
    };
  }

  return (
    <Controller
      key={name}
      control={control}
      name={`${name}.date`}
      render={({ field }) => (
        <Select
          value={dateToString(field.value)}
          disabled={disabled}
          onChange={(svalue) => {
            const oldValue = field.value;
            const newValue = stringToTime(svalue);
            field.onChange(
              new Date(
                oldValue?.getFullYear() || 0,
                oldValue?.getMonth() || 0,
                oldValue?.getDate() || 0,
                newValue.hours,
                newValue.minutes,
              ),
            );
          }}
          options={generateTimeOptions()}
        />
      )}
    />
  );
}
